import React from 'react';
import { translate } from 'react-i18next';

const DocsMenu = (props) => {
  return (
    <div className="row">
      <nav className="col-md-2 d-none d-lg-block bg-light sidebar">
        <div className="sidebar-sticky">
          <ul className="nav flex-column sidenav">
            <li className="nav-item">
              <a className="nav-link" href="#overview">
                <span data-feather="home"></span>
                {props.t('overview')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#authentication">
                {props.t('authentication')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#pagination">
                {props.t('pagination')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#errors">
                {props.t('errors')}
              </a>
            </li>
          </ul>

          <h6 className="sidebar-heading uppercase d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            {props.t('resources')}
          </h6>
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              <a className="nav-link" href="#personal-information">
                {props.t('personalData.menuItem')}
              </a>
              <ul className="nav flex-column submenu">
                <li className="nav-item">
                  <a className="nav-link" href="#find-by-ssn">
                  <span className="badge badge-pill badge-dark">GET</span> {props.t('personalData.socialSecurityNo')}
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#find-by-name">
                  <span className="badge badge-pill badge-dark">GET</span> {props.t('personalData.name')}
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#find-by-phone">
                  <span className="badge badge-pill badge-dark">GET</span> {props.t('personalData.phone')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#business-data">
                <span data-feather="file-text"></span>
                {props.t('businessData.menuItem')}
              </a>
              <ul className="nav flex-column submenu">
                <li className="nav-item">
                  <a className="nav-link" href="#find-business-by-id">
                  <span className="badge badge-pill badge-dark">GET</span> {props.t('businessData.id')}
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a className="nav-link" href="#find-business-by-name">
                  <span className="badge badge-pill badge-dark">GET</span> {props.t('businessData.name')}
                  </a>
                </li> */}
              </ul>              
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default translate('DocsMenu')(DocsMenu);



// WEBPACK FOOTER //
// ./src/components/DocsMenu.js